const Error = () => import("@/pages/auth/error.vue");
const Login = () => import("@/pages/auth/login");
const Register = () => import("@/pages/auth/register");
const ForgotPassword = () => import("@/pages/auth/forgot-password");
const VerifyOTP = () => import("@/pages/auth/verify-otp");
const UpdatePassword = () => import("@/pages/auth/update-password");
const Invite = () => import("@/pages/auth/invite");

// Vendor Access
const VendorLogin = () => import("@/pages/vendorLogin");
const VendorLoginProcessing = () => import("@/pages/vendorLoginProcessing");

const routes = () => {
  return [
    {
      path: "*",
      name: "error",
      component: Error,
      meta: {
        guest: true,
        layout: "auth"
      }
    },
    {
      path: "/",
      redirect: {
        path: "/login",
        component: Login
      },
      meta: {
        guest: true,
        layout: "auth"
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        guest: true,
        layout: "auth"
      }
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      meta: {
        guest: true,
        layout: "auth"
      }
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      component: ForgotPassword,
      meta: {
        guest: true,
        layout: "auth"
      }
    },
    {
      path: "/verify-otp",
      name: "verify-otp",
      component: VerifyOTP,
      meta: {
        guest: true,
        layout: "auth"
      }
    },
    {
      path: "/update-password",
      name: "update-password",
      component: UpdatePassword,
      meta: {
        guest: true,
        layout: "auth"
      }
    },
    {
      path: "/invite",
      redirect: {
        path: "/register",
        component: Register
      },
      meta: {
        guest: true,
        layout: "auth"
      }
    },
    {
      path: "/invite/:token",
      name: "invite",
      component: Invite,
      meta: {
        guest: true,
        layout: "auth"
      }
    },
    {
      path: "/vendor-login/:appCode/:sessionToken",
      name: "vendor-login",
      component: VendorLogin,
      meta: {
        guest: true
      }
    },

    {
      path: "/vendor-login-processing",
      name: "vendor-login-processing",
      component: VendorLoginProcessing,
      meta: {
        guest: true
      }
    }
  ];
};

export default routes();
